import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);
const KEY = "szn_lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    return saved === "en" || saved === "fr" ? saved : "fr";
  });

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem(KEY, l);
    if (typeof document !== "undefined") document.documentElement.lang = l;
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
